import { Flame, Sparkles, UserPlus } from "lucide-react";

/**
 * FanLevelBadge — kompaktes Trust-Signal für Seller.
 * Farbschema:
 *   TOP_FAN    → Salmon-Solid + Flame
 *   ACTIVE_FAN → Salmon-Soft-Outline + Sparkles
 *   NEW_FAN    → Neutral-Border + UserPlus
 */
const LEVELS = {
  TOP_FAN: {
    label: "Top-Fan",
    icon: Flame,
    className: "bg-stx-accent text-stx-accent-fg border-stx-accent",
    classNameLegacy: "bg-[#0A0A0A] text-white border-[#0A0A0A]",
  },
  ACTIVE_FAN: {
    label: "Aktiver Fan",
    icon: Sparkles,
    className: "bg-stx-accent-soft text-stx-accent border-stx-accent",
    classNameLegacy: "bg-white text-[#0A0A0A] border-[#0A0A0A]",
  },
  NEW_FAN: {
    label: "Neuer Fan",
    icon: UserPlus,
    className: "bg-transparent text-stx-text-muted border-stx-border",
    classNameLegacy: "bg-transparent text-[#666] border-[#E5E5E5]",
  },
};

export default function FanLevelBadge({ level, area = "STX", size = "sm", showLabel = true }) {
  if (!level || !LEVELS[level]) return null;
  const meta = LEVELS[level];
  const Icon = meta.icon;
  const cls = area === "STX" ? meta.className : meta.classNameLegacy;
  const iconSize = size === "xs" ? 9 : 11;
  return (
    <span
      data-testid={`fan-badge-${level.toLowerCase()}`}
      className={`inline-flex items-center gap-1 h-5 px-1.5 rounded-full border text-[9px] font-semibold uppercase tracking-wider ${cls}`}
      title={meta.label}
    >
      <Icon size={iconSize} />
      {showLabel && <span>{meta.label}</span>}
    </span>
  );
}
